<template>
  <card-minimal
    :title="title"
    :titleLink="!compact && maxpage > 1 && state === '' ? titleLink : ''"
    :titleLinkText="!compact && maxpage > 1 && state === '' ? titleLinkText : ''"
    :class="`broadcast-list ${compact ? 'no-bg' : ''} no-shadow`"
    v-if="state === 'loading' || (state === '' && broadcasts.length > 0)"
  >
    <div class="loading" v-if="state === 'loading'">
      <i class="mdi mdi-loading mdi-spin" />
    </div>
    <template v-else>
      <list :compact="compact">
        <template v-if="compact" v-slot:header>
          <th class="w-66p">
            <span>Broadcast</span>
          </th>
          <th :class="`w-33 ta-c sortable ${typeof $route.query.sort !== 'undefined' && $route.query.sort === 'scheduled_start_time' ? 'sorting' : ''} ${typeof $route.query.direction !== 'undefined' && $route.query.direction === 'asc' ? 'asc' : ''}`" @click="sort('scheduled_start_time')"><span>Start time</span></th>
        </template>
        <broadcast-item
          :broadcast="broadcast"
          :compact="compact"
          v-for="(broadcast, index) in broadcasts"
          :key="index"
          :showType="showType"
        />
      </list>
      <pagination class="m-t-4" :page="currentpage" :maxPage="maxpage" @page="page" v-if="compact" />
    </template>
  </card-minimal>
</template>

<script>

import BroadcastItem from '@/components/Broadcast/Item.vue';
import Pagination from '@/components/Lists/Pagination.vue';

export default {
  components: {
    BroadcastItem,
    Pagination,
  },
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    titleLink: {
      type: String,
      default: '',
    },
    titleLinkText: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      required: true,
    },
    sortOn: {
      type: String,
      default: null,
    },
    perPage: {
      type: Number,
      default: null,
    },
    direction: {
      type: String,
      default: null,
    },
    showType: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    sort(sort) {
      let { direction } = this.query;

      if (this.query.sort === sort) {
        direction = direction !== 'desc' ? 'desc' : 'asc';
      }

      this.query.direction = direction;
      this.query.sort = sort;

      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          direction,
          sort,
        },
      });

      this.getBroadcasts();
    },
    page(page) {
      this.currentpage = page;

      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page,
        },
      });

      this.getBroadcasts();
    },
    async getBroadcasts() {
      const { query, currentpage } = this;

      const payload = {
        page: 1,
        per_page: this.per_page,
        type: this.status,
        skipConf: true,
        skipState: true,
      };

      if (query.sort) {
        payload.sort = query.sort;
      }

      if (query.direction) {
        payload.direction = query.direction;
      }

      payload.page = currentpage;

      const { broadcasts, pagination } = await this.$store.dispatch('Broadcasts/getBroadcasts', payload);

      this.broadcasts = broadcasts;
      this.maxpage = pagination.max_page;
      this.currentpage = pagination.current_page;
    },
  },
  async mounted() {
    this.currentpage = typeof this.$route.query.page !== 'undefined' ? parseInt(this.$route.query.page, 10) : 1;
    // eslint-disable-next-line
    this.query.direction = typeof this.$route.query.direction !== 'undefined' ? this.$route.query.direction : this.direction ? this.direction : this.status === 'upcoming' ? 'asc' : 'desc';
    // eslint-disable-next-line
    this.query.sort = typeof this.$route.query.sort !== 'undefined' ? this.$route.query.sort : this.sortOn ? this.sortOn : 'scheduled_start_time';
    if (this.compact) {
      this.per_page = 15;
    }

    if (this.perPage) {
      this.per_page = this.perPage;
    }

    await this.getBroadcasts();

    this.$emit('numItems', this.broadcasts.length > 0);

    this.state = '';
  },
  data() {
    return {
      state: 'loading',
      broadcasts: [],
      maxpage: 1,
      currentpage: 1,
      per_page: 5,
      query: {
        sort: 'scheduled_start_time',
        direction: 'desc',
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.loading {
  padding: 50px;
  text-align: center;

  i {
    color: var(--color-loading);
    font-size: 60px;
    line-height: 60px;
  }
}
</style>
